<dx-scroll-view
    height="100%"
    width="100%"
    class="view-wrapper-scroll single-card"
>
    <app-card-auth [title]="title" [description]="description">
        <ng-content></ng-content>
    </app-card-auth>

    <footer class="p-4">
        <div class="text-center fs-2 mb-2 fw-bold text-white">LESS CHAIN. MORE SUPPLY.</div>
        <div class="text-center fs-6 text-white">Customized Dedicated Supply Chain Solutions</div>
    </footer>
</dx-scroll-view>
